export default __webpack_public_path__ + "static/media/Marco-Resume-2021.b437a8b7.pdf";